import type { ListenerEffectAPI, PayloadAction } from "@reduxjs/toolkit";
import { isAnyOf } from "@reduxjs/toolkit";
import { makeSelectSelectedObjectVersion } from "../../../../../app/state/storageObjectSlice/selectors";
import { setSelectedVersionId } from "../../../../../app/state/storageObjectSlice/slice";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { serviceHandlers } from "../handlers/storageHandlers";
import { StorageScope } from "../../../../api/instances/storageApi/types/service_types";

export function selectStorageObjectVersionListener() {
  appListenerMiddleware.startListening({
    matcher: isAnyOf(setSelectedVersionId),
    effect: async (
      action: PayloadAction<{
        service: StorageScope;
        version_id: string | null;
      }>,
      listenerApi,
    ) => {
      const state = listenerApi.getState() as RootState;
      const { service, version_id } = action.payload;
      if (!version_id) return;

      const storageObjectVersion =
        makeSelectSelectedObjectVersion(service)(state);

      if (!storageObjectVersion) return;

      const value = storageObjectVersion.value;
      const handler = serviceHandlers[service];
      if (handler?.onSelectVersion) {
        await handler.onSelectVersion(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
          version_id,
          value,
        );
      }
    },
  });
}
